
<template>
  <div>
    <div class="naviTit01">
      {{ naviInfo.name }}
    </div>

    <el-row>
      <div
        v-for="(item,index) in naviInfo.subNodes"
        :key="index"
      >
        <!--no child-->
        <el-col
          v-if="!item.subNodes"
          :span="6"
        >
          <div
            :key="index+1"
            class="cardInfo"
            :index="index.toString()"
            @click="siderClick(item)"
          >
            <img
              src="~@/assets/img/mall_bg.png"
              class="image"
            >
            <p>{{ item.name }}</p>
          </div>
        </el-col>
        <!-- 有子菜单 -->
        <el-row
          v-else
          :key="index+1"
          class="one"
          :index="index.toString()"
        >
          <div class="naviTit02">
            {{ item.name }}
          </div>
          <el-col
            v-for="(ite,i) in item.subNodes"
            :key="i+1"
            :span="6"
          >
            <div
              class="cardInfo"
              :index="index.toString()"
              @click="siderClick(ite)"
            >
              <img
                src="~@/assets/img/mall_bg.png"
                class="image"
              >
              <p>{{ ite.name }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      naviInfo: ''
    }
  },
  computed: {},
  watch: {
    $route: {
      handler(val) {
        const that = this
        that.naviInfo = JSON.parse(val.query.naviInfo)
        // 在这里做你要做的事
      },
      deep: true // 深度监听
    }
  },
  created() {
    console.log(JSON.parse(this.$route.query.naviInfo))
    this.naviInfo = JSON.parse(this.$route.query.naviInfo)
  },
  mounted() {},
  methods: {
    siderClick(item) {
      this.$router.push(item.path)
    }
  }
}
</script>

